import React from "react";
import { Button } from "@material-ui/core";
import { makeStyles } from "@material-ui/styles";
import palette from "../../styles/palette";

const useStyles = makeStyles(() => ({
  button: {
    minWidth: "3.125rem",
    color: palette.snackbarButtons.yellow,
  },
}));

const ActionButton = ({ children, onClick }) => {
  const classes = useStyles();

  return (
    <Button
      color="secondary"
      size="small"
      className={classes.button}
      onClick={onClick}
    >
      {children}
    </Button>
  );
};

export default ActionButton;
